
import { Component, VModel, Prop } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'
@Component({
    mixins: [ProjectMixin],
    inheritAttrs: false,
})
export default class ChartTypeFilter extends Mixins<MixinInterface>(ProjectMixin) {
    @VModel() filter!: Array<string>
    @Prop() settings!: Record<string, any>

    get charts() {
        return [
            { text: this.$t(`chart.bar`), value: 'bar' },
            { text: this.$t(`chart.line`), value: 'line' },
            { text: this.$t(`chart.pie`), value: 'pie', disabled: !!this.settings.aggregatePeriod },
        ]
    }
}
